import {
  Component,
  Input,
  Optional,
  Host,
  OnInit,
  EventEmitter,
  Output,
  HostBinding,
  ChangeDetectorRef,
  ViewEncapsulation
} from "@angular/core";
import { FormGroup, ControlContainer, FormControl } from "@angular/forms";

@Component({
  selector: "lxm-datepicker",
  templateUrl: "./datepicker.component.html",
  styleUrls: ["./datepicker.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class LxmDatepickerComponent implements OnInit {
  @HostBinding("class.readonly")
  @Input()
  public readonly = false;

  @HostBinding("class.disabled")
  @Input()
  public disabled = false;

  @Input() public formGroup: FormGroup;
  @Input() public for: string;
  @Input() public width = "100%";
  @Input() public min: any;
  @Input() public max: any;
  @Input() public offset = null;
  @Input() public inputId: string;
  @Input() public placeholder: string;

  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();

  @Input() dateFilter: (date: Date | null) => boolean;

  constructor(
    @Optional() @Host() private _controlContainer: ControlContainer,
    private _cd: ChangeDetectorRef
  ) { }

  public ngOnInit(): void {
    if (
      this._controlContainer &&
      this._controlContainer.control instanceof FormGroup
    ) {
      this.formGroup = <FormGroup>this._controlContainer.control;
    }
  }

  public onChange(event: any): void {
    this.change.emit(event);
  }

  public onBlur(event: any): void {
    this.blur.emit(event);
  }
}
